import { useState } from "react";

export default function CodeEditor({ problem, onSubmit }) {
  const [code, setCode] = useState(problem?.codeTemplate || "");

  const handleSubmit = () => {
    if (onSubmit && code.trim()) {
      onSubmit(code);
    }
  };

  return (
    <div className="bg-white h-full rounded shadow p-8 flex flex-col">
      <h2 className="text-lg font-semibold mb-4">Coding Question</h2>

      {/* Problem Description */}
      <div className="mb-4">
        <h3 className="font-medium mb-2">Problem:</h3>
        <p className="text-gray-700">
          {problem?.questionText || problem?.question}
        </p>
      </div>

      {/* Sample Input/Output */}
      {(problem?.sampleInput || problem?.sampleOutput) && (
        <div className="grid grid-cols-2 gap-4 mb-4">
          {problem?.sampleInput && (
            <div>
              <h4 className="font-medium text-sm mb-1">Sample Input:</h4>
              <pre className="bg-gray-100 p-2 rounded text-sm">
                {problem.sampleInput}
              </pre>
            </div>
          )}
          {problem?.sampleOutput && (
            <div>
              <h4 className="font-medium text-sm mb-1">Sample Output:</h4>
              <pre className="bg-gray-100 p-2 rounded text-sm">
                {problem.sampleOutput}
              </pre>
            </div>
          )}
        </div>
      )}

      {/* Constraints */}
      {problem?.constraints && (
        <div className="mb-4">
          <h4 className="font-medium text-sm mb-1">Constraints:</h4>
          <p className="text-gray-600 text-sm">{problem.constraints}</p>
        </div>
      )}

      {/* Code Editor */}
      <div className="flex-1 flex flex-col mb-4">
        <h4 className="font-medium text-sm mb-2">Your Solution:</h4>
        <textarea
          className="flex-1 border font-mono p-4 text-sm resize-none"
          placeholder="Write your solution here..."
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
      </div>

      {/* Submit Button */}
      <div className="flex justify-end">
        <button
          onClick={handleSubmit}
          disabled={!code.trim()}
          className={`px-8 py-2 rounded ${
            code.trim()
              ? "bg-blue-600 hover:bg-blue-700 text-white"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
        >
          Submit Solution
        </button>
      </div>
    </div>
  );
}
